import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';

function rankColor(r) {
  if (r < 10) return '#9aa0a6';
  if (r < 20) return '#e53935';
  if (r < 30) return '#fb8c00';
  if (r < 40) return '#fdd835';
  if (r < 50) return '#43a047';
  if (r < 60) return '#1e88e5';
  if (r < 80) return '#3949ab';
  return '#8e24aa';
}

export default class RankingPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.all = null;
    this.page = 0;
    this.perPage = 15;
    this.loadAll();
  }

  loadAll() {
    const acc = [];
    const me = app.session && app.session.user;
    const fetchPage = (offset) =>
      app.store.find('users', { sort: '-commentCount', page: { limit: 50, offset } }).then((users) => {
        users.forEach((u) => acc.push(u));
        if (users.length === 50 && acc.length < 300) {
          return fetchPage(offset + 50);
        }
      });

    fetchPage(0)
      .then(() => {
        this.all = acc;
        if (me) {
          const idx = acc.findIndex((u) => u.id() === me.id());
          if (idx >= 0) this.page = Math.floor(idx / this.perPage);
        }
        m.redraw();
      })
      .catch(() => {
        this.all = [];
        m.redraw();
      });
  }

  view() {
    if (this.all == null) {
      return m('div', { className: 'RankingPage' }, m('div', { className: 'container' }, m(LoadingIndicator)));
    }
    const total = this.all.length;
    const pages = Math.max(1, Math.ceil(total / this.perPage));
    if (this.page >= pages) this.page = pages - 1;
    const start = this.page * this.perPage;
    const slice = this.all.slice(start, start + this.perPage);
    return m('div', { className: 'RankingPage' }, m('div', { className: 'container' }, [
      m('h2', { className: 'kb-ranking-title' }, '회원 랭킹'),
      m('ol', { className: 'kb-ranking-list' }, slice.map((u, i) => this.row(u, start + i + 1))),
      this.pagination(pages),
    ]));
  }

  pagination(pages) {
    if (pages <= 1) return null;
    const btns = [];
    for (let p = 0; p < pages; p++) {
      btns.push(
        m(
          'button',
          {
            className: 'kb-page-btn' + (p === this.page ? ' active' : ''),
            onclick: () => {
              this.page = p;
              window.scrollTo(0, 0);
            },
          },
          p + 1
        )
      );
    }
    return m('div', { className: 'kb-ranking-pagination' }, btns);
  }

  row(user, place) {
    const rank = user.attribute('kbRank') || 1;
    const cc = user.attribute('commentCount') || 0;
    const col = rankColor(rank);
    const me = app.session && app.session.user;
    const isMe = me && user.id() === me.id();
    return m('li', { className: 'kb-ranking-row' + (isMe ? ' kb-ranking-me' : '') }, [
      m('span', { className: 'kb-ranking-place' }, place),
      m('span', { className: 'kb-ranking-lv', style: 'background:' + col + ';' }, rank),
      m(Link, { className: 'kb-ranking-user', href: app.route('user', { username: user.slug() }) }, [
        avatar(user),
        m('span', { className: 'kb-ranking-name' }, username(user)),
      ]),
      m('span', { className: 'kb-ranking-posts' }, cc + '글'),
    ]);
  }
}
